// extracted by mini-css-extract-plugin
export default {"floatButton":"_5076077a7f","floatButtonCard":"_439cbffd62"};